import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import commonAxios from "@/views/csr/common/axios";

Vue.use(VueRouter);

const routes = [
  // default
  {
    path: "/",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "Login" */ "../views/Login.vue"),
    meta: { view_for: "default" },
  },
  {
    path: "/form",
    name: "Loginform",
    component: () =>
      import(/* webpackChunkName: "Login" */ "../views/Login_form.vue"),
    meta: { view_for: "default" },
  },
  {
    path: "/ms/login/callback",
    name: "Mslogin",
    component: () =>
      import(/* webpackChunkName: "Login" */ "../views/Callback.vue"),
    meta: { view_for: "default" },
  },

  // global/ multi access
  {
    path: "/dashboard",
    name: "Dashboard",
    components: {
      admin: () => import("../views/admin/Dashboard/Dashboard.vue"),
      // tma: () => import("../views/agent/Dashboard/Dashboard.vue"),
      tma: () => import("../views/agent/Dashboard/V2/DashboardModule.vue"), //new
      doctor: () => import("../views/doctor/Dashboard/Dashboard.vue"),
      csr: () => import("@/views/csr/pages/Dashboard"),
    },
    meta: { view_for: ["admin", "tma", "doctor", "csr"] },
  },
  {
    path: "/schedule",
    name: "Schedule",
    components: {
      admin: () => import("../views/admin/Schedule/Scheduler.vue"),
      tma: () => import("../views/agent/Schedule/Schedule.vue"),
      doctor: () => import("../views/doctor/Schedule/Schedule.vue"),
    },
    meta: { view_for: ["admin", "doctor", "tma"] },
  },

  {
    path: "/preferences",
    name: "Preferences",
    components: {
      doctor: () => import("../views/doctor/Preferences/Preference.vue"),
    },
    meta: { view_for: ["doctor"] },
  },

  // admin
  {
    path: "/users/:id?",
    name: "Users",
    component: () => import("../views/admin/Users/Users.vue"),
    meta: { view_for: ["admin"], force_default: true },
  },

  // agent
  {
    path: "/cases/:id?",
    name: "Cases",
    component: () => import("../views/agent/Cases/Cases.vue"),
    meta: { view_for: ["tma"], force_default: true },
  },

  // audio-video call window
  {
    path: "/call",
    name: "Call",
    components: {
      doctor: () =>
        import("../views/doctor/Dashboard/components/call/Call.vue"),
    },
    meta: { view_for: ["doctor"] },
  },
  // password reset
  {
    path: "/password/reset/",
    name: "Password",
    query: { email: '', code: '' },
    component: () =>
      import("../views/main/Password/Password.vue")
      
  },

  // home
  {
    path: "/home",
    name: "Home",
    component: () =>
      import(/* webpackChunkName: "Home" */ "../views/main/Home/Home.vue"),
  },

  // // for testing
  // {
  //   path: '/test',
  //   name: 'Test',
  //   component: ()=> import(/* webpackChunkName: "Test" */ '../components/main/form/CaseSummaryCare.vue')
  // }

  {
    path: "/backroom-chat/:chatRoomSlug?",
    name: "Backroom Chat",
    component: () => import("@/views/csr/pages/Chat"),
  },

  {
    path: "/backroom-notification",
    name: "Backroom Notification",
    component: () => import("@/views/csr/pages/Notification"),
  },
  {
    path: "/dashboard2",
    name: "Dashboard2",
    components: {
      admin: () => import("../views/admin/Dashboard/Dashboard.vue"),
      tma: () => import("../views/agent/Dashboard/Dashboard.vue"), //old
      // tma: () => import("../views/agent/Dashboard/V2/DashboardModule.vue"),
      doctor: () => import("../views/doctor/Dashboard/Dashboard.vue"),
      csr: () => import("@/views/csr/pages/Dashboard"),
    },
    meta: { view_for: ["admin", "tma", "doctor", "csr"] },
  },
];

const router = new VueRouter({
  routes,
  mode: 'history'
});

router.beforeEach( async (to, from, next) => {
  const auth_token = store.getters["profile/token"];
  const user_type = store.getters["profile/type"];
  const view_for = to.meta.view_for;


  // go to login if no token and accessing not login views
  if (to.name !== "Login" && to.name !== "Home" && to.name !== "Password" && to.name !== 'Mslogin' && to.name !== 'Loginform' && !auth_token) {

    next({ name: "Login" });

  } else if (to.name === "Login" && auth_token) {

    // go to dashboard if accessing login views
    // go to dashboard if view not intended for user type
    next({ name: "Dashboard" });

  } else if ( view_for !== "default" && Array.isArray(view_for) && !view_for.includes(user_type)) {

    next({ name: "Dashboard" });
  
  } else if (!auth_token) {

    let loginType = 'form';
    let sessionKey = localStorage.getItem('login_session_key');

    if (sessionKey == null || sessionKey == undefined) {
      localStorage.setItem('login_session_key', Math.random().toString(36).substring(2,16));
    }
    
    const res = await commonAxios.get(`/setting?primary_key=ms_login&session_key=${sessionKey}`);

    console.log(res.data)

    if (res.status == 200) {
      loginType = res.data[0].value == "1" ? "ms" : "form";
      let urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has('login_key')) {
        loginType = 'form';
      }
    }
  
    if (to.name === "Login" && loginType == 'form') {
      next ({name: "Loginform"});
    } else if (to.name === "Loginform" && loginType == 'ms') {
      next ({name: "Login"});
    } else {
      next();
    }

  } else {

    // proceed normally
    next(); 

  }
});

export default router;
